module.exports = __webpack_public_path__ + "static/brand04-a7913c92fa5a3fb44958e87658582b7d.png";